export const createInvite = (phoneNumber) => `mutation createInvite {
  createInvite(phoneNumber: "${phoneNumber}") {
    id
    phoneNumber
    status
  }
}`;

export default createInvite;